import React from "react";
import { STATUS_STYLES, STATUS_LABEL } from "@/utils";

export function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || "bg-zinc-100 text-zinc-700 border-zinc-300";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2 py-0.5 border rounded-md text-[11px] font-medium uppercase tracking-wide ${style} ${className}`}
    >
      {STATUS_LABEL[status] || status}
    </span>
  );
}
